import angular from 'angular';
import { createElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { withProviders } from '../../../core/components';
import Banner from './Banner';
/* <banner> */
export default angular.module('doxy.banners.banner', []).component('banner', {
    bindings: {
        anchorId: '@',
        placement: '@',
        title: '@',
        description: '@',
        onClose: '&',
        margin: '<?',
        className: '@?',
        portalContainer: '<?',
    },
    controller: class {
        constructor($element) {
            this.$element = $element;
        }
        $onInit() {
            render(createElement(withProviders(() => Banner({
                title: this.title,
                placement: this.placement,
                description: this.description,
                anchorId: this.anchorId,
                onClose: this.onClose,
                margin: this.margin,
                className: this.className,
                portalContainer: this.portalContainer,
            }))), this.$element[0]);
        }
        $onDestroy() {
            unmountComponentAtNode(this.$element[0]);
        }
    },
}).name;
